import { render } from "./LinkageChangePassword.vue?vue&type=template&id=f7c8de46&ts=true"
import script from "./LinkageChangePassword.vue?vue&type=script&lang=ts"
export * from "./LinkageChangePassword.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1111083459/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__